import script from "./about.vue?vue&type=script&setup=true&lang=js"
export * from "./about.vue?vue&type=script&setup=true&lang=js"

import "./about.vue?vue&type=style&index=0&id=07075865&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07075865"]])

export default __exports__